import { AuxiliumComponent } from "../auxilium-component";

export default class ChipOption extends AuxiliumComponent {
	static observable = ["value"];
}
